import { render, staticRenderFns } from "./knowledgeview.vue?vue&type=template&id=61ce11c0"
import script from "./knowledgeview.vue?vue&type=script&lang=js"
export * from "./knowledgeview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports